import * as React from 'react';
import { useEffect, useState } from 'react';
import { batch, useDispatch } from 'react-redux';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { useUser } from 'src/components/hooks/useUser';
import { useCreateQueryMutation, useUpdateQueryMutation } from 'src/services/Queries';
import { useAppSelector } from 'src/store/hooks';
import { hideLoader, setProgress, showLoader } from 'src/store/Loader';
import { setMessage } from 'src/store/Message';
import { IMessage } from 'src/types/Message';
import { ICreateQuery, IUpdateQuery } from 'src/types/Queries';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';

export const useRaiseQuery = (
  setOpenRaiseQuery: (boolean: boolean) => void,
  queryKeys: any,
  queryType: string,
  getSivReportQueries: () => void,
  report_id?: string | undefined,
  reportQueryId?: number,
  prevAssign?: string,
  fieldQueries?: any,
  forwardQueryId?: string
) => {
  const isMilestoneQuery = Object.keys(queryKeys).includes('section_key') && queryKeys.section_key === 'MileStone';
  const dispatch = useDispatch();
  const { selectedAppSection } = useSelectedAppInfo();
  const [sendTo, setSendTo] = React.useState('');
  const [msg, setMsg] = React.useState('');
  const { user } = useUser();

  const handleChange = (event: any) => {
    setSendTo(event);
    setValidationObj({ ...validationObj, report_send_to: false });
  };

  const handleMsgChange = (event: any) => {
    setMsg(event.target.value);
    setValidationObj({ ...validationObj, [event.target.name]: false });
  };
  const handleClosenew = () => {
    setOpenRaiseQuery(false);
    setMsg('');
    setSendTo('');
    setValidationObj({
      report_comment: false,
      report_send_to: false
    });
  };

  const errorText = 'Required!';
  const [validationObj, setValidationObj] = useState({
    report_comment: false,
    report_send_to: false
  });

  const { raiseQueryErrorMsg, raiseQuerySuccessMsg } = useFieldTranslation();

  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);

  const [createQuery, { isLoading: _isCreating, isSuccess: _createSuccess, isError: _createError }] =
    useCreateQueryMutation();

  const [updateQuery, { isLoading: _isUpdating, isSuccess: _updateSuccess, isError: _updateError }] =
    useUpdateQueryMutation();

  const getModuleSection = () => {
    return queryKeys.report_category === 'SUSIVRT'
      ? 'SIV REPORT'
      : queryKeys.report_category === 'SQREPT'
      ? 'SQ REPORT'
      : queryKeys.report_category === 'SUMILST'
      ? 'MILESTONE TRACKING'
      : '';
  };
  useEffect(() => {
    if (_isCreating) {
      dispatch(setProgress(_isCreating));
    }
  }, [_isCreating]);
  useEffect(() => {
    if (_isUpdating) {
      dispatch(setProgress(_isUpdating));
    }
  }, [_isUpdating]);

  const sendFieldQuery = async () => {
    const newObj = { ...validationObj };
    const validationArr: any = [];

    if (sendTo == '' || sendTo == null) {
      newObj.report_send_to = true;
      validationArr.push(true);
    } else {
      newObj.report_send_to = false;
      validationArr.push(true);
    }

    if (msg == '' || msg == null) {
      newObj.report_comment = true;
      validationArr.push(false);
    } else {
      newObj.report_comment = false;
      validationArr.push(true);
    }
    setValidationObj(newObj);

    if (!validationArr.includes(false)) {
      dispatch(showLoader());
      let reqObj;
      if (queryType === 'Forward') {
        const resQuery = fieldQueries.filter((query: any) => {
          if (query.query.id == forwardQueryId) {
            return query.query;
          }
        });
        reqObj = {
          report_category: queryKeys.report_category,
          report_section_name: queryKeys.report_section_name,
          report_field_name: queryKeys.report_field_name,
          report_field_label: queryKeys.report_field_label,
          report_field_value: queryKeys.report_field_value,
          report_query_type: isMilestoneQuery ? 'Field' : resQuery[0].query.report_query_type,
          report_comment: msg,
          report_send_to: prevAssign,
          report_forward_to: sendTo,
          report_is_opened: true,
          report_status: '',
          report_id: isMilestoneQuery ? queryKeys.id : report_id,
          report_query_id: reportQueryId,
          updated_by: user
        };
        const updateObj = {
          site_id: selectedSite == null ? '' : selectedSite,
          study_id: studyId,
          country: selectedCountry == null ? '' : selectedCountry,
          application: process.env.REACT_APP_NAME,
          data: reqObj as IUpdateQuery,
          application_section: selectedAppSection,
          application_module_section: getModuleSection()
        };
        // if (hasConductRaiseQueryPermission) {
        //   updateMilestoneQuery(updateObj);
        // } else {
        updateQuery(updateObj);
        // }
      } else {
        reqObj = {
          report_id: isMilestoneQuery ? queryKeys.id : report_id,
          report_category: queryKeys.report_category,
          report_section_name: queryKeys.report_section_name,
          report_field_name: queryKeys.report_field_name,
          report_field_label: queryKeys.report_field_label,
          report_field_value: queryKeys.report_field_value,
          report_query_type: isMilestoneQuery ? 'Field' : queryType,
          report_comment: msg,
          report_send_to: sendTo,
          report_forward_to: '',
          report_is_opened: true,
          report_status: '',
          created_by: user
        };
        const createObj = {
          site_id: selectedSite == null ? '' : selectedSite,
          study_id: studyId,
          country: selectedCountry == null ? '' : selectedCountry,
          application: process.env.REACT_APP_NAME,
          data: reqObj as ICreateQuery,
          application_section: selectedAppSection,
          application_module_section: getModuleSection()
        };
        // if (hasConductRaiseQueryPermission) {
        //   createMilestoneQuery({ ...createObj, application_section: 'CONDUCT' });
        // } else {
        createQuery(createObj);
        // }
      }
    }
  };

  useEffect(() => {
    if (_createSuccess) {
      afterCreate(createSuccessMessage(), true);
    }
  }, [_createSuccess]);

  useEffect(() => {
    if (_updateSuccess) {
      afterCreate(updateSuccessMessage(), true);
    }
  }, [_updateSuccess]);
  useEffect(() => {
    if (_updateError) {
      afterCreate(updateErrorMessage(), false);
    }
  }, [_updateError]);

  useEffect(() => {
    if (_createError) {
      afterCreate(createErrorMessage(), false);
    }
  }, [_createError]);

  const afterCreate = (msg: IMessage, _: boolean) => {
    batch(() => {
      getSivReportQueries();
      handleClosenew();
      dispatch(hideLoader());
      dispatch(setMessage(msg));
    });
  };

  const updateSuccessMessage = (): IMessage => {
    return { msgDetails: 'Forwarded successfully', severity: 'success' };
  };

  const updateErrorMessage = (): IMessage => {
    return { msgDetails: 'Error in forwarding', severity: 'error' };
  };

  const createSuccessMessage = (): IMessage => {
    return { msgDetails: raiseQuerySuccessMsg, severity: 'success' };
  };

  const createErrorMessage = (): IMessage => {
    return { msgDetails: raiseQueryErrorMsg, severity: 'error' };
  };

  return { handleClosenew, handleChange, handleMsgChange, sendFieldQuery, validationObj, errorText, sendTo, msg };
};
